import React, { useContext, useRef } from 'react'

import { Box, Icon, Tooltip } from '@driftt/dds'
import { faCircleInfo } from '@driftt/dds.icons/light/faCircleInfo'

import { CurrentUserContext } from 'context/currentUserContext'
import { useDebouncedCallback } from 'hooks/useDebouncedCallback'
import { segmentTrack, TrackType } from 'utils/tracking'

const ScoreGraphTooltip = () => {
  const containerRef = useRef<HTMLDivElement>(null)
  const currentUser = useContext(CurrentUserContext)

  const debouncedMouseEvent = useDebouncedCallback((toggle: boolean) => {
    if (toggle) {
      segmentTrack(TrackType.SCORE_GRAPH_TOOLTIP_HOVER, {
        userId: currentUser?.id,
        orgId: currentUser?.orgId
      })
    }
  }, 100)

  return (
    <Box
      onMouseEnter={() => {
        debouncedMouseEvent(true)
      }}
      onMouseLeave={() => debouncedMouseEvent(false)}
      ref={containerRef}
      css={{
        fontSize: '$half',
        position: 'relative',
        display: 'block'
      }}>
      <Tooltip content="How the engagement score has changed in the last 2 weeks.">
        <Icon
          css={{
            width: '10px',
            height: '10px',
            cursor: 'pointer'
          }}
          icon={faCircleInfo}
        />
      </Tooltip>
    </Box>
  )
}

export default ScoreGraphTooltip
